import { render, staticRenderFns } from "./TemplateOptions.vue?vue&type=template&id=e9dd7e4c"
import script from "./TemplateOptions.vue?vue&type=script&lang=ts"
export * from "./TemplateOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports